<div class="card-header" >
    <h4>Add Product</h4>
</div>
<div class="card">
    <div class="row">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'product'" >Product Details</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'commission'" >Service Charges</a>
            </li>
        </ul>
    </div>
<div class="tab-content" id="myTabContent">
  <div id="product" class="tab-pane fade active show" [ngStyle]="{ 'display': activeTab === 'product'? 'block' : 'none'}">
    <form #productAdd="ngForm" (ngSubmit)="addProduct(productAdd.value)" [formGroup]="addProductForm">
    <div class="row">
        <div class="col-sm-6 mb-3 mb-sm-0">
            <div class="card border-0 shadow-none text-center">
              <div class="card-body ">
                  <img [src]="selectedFile"  width="150" height="150" class="rounded-circle mb-3" alt="category Image">
                  <br>
                  <div class="custom-file">
                    <div class="file btn btn-lg bg-primary">
                  Upload &nbsp;<i class="fa fa-upload"></i>
                  <input type="file" [ngClass]="{'is-invalid':submitted && addProductForm.controls.productImage.errors}" accept="image/*" (change)="setProductProfile($event)">
                  </div>
                  </div>
                  <div class="invalid-feedback mt-2" style="display: block;" id="fileNameDisplay"
                              *ngIf="submitted && addProductForm.controls.productImage.errors">
                              <div *ngIf="addProductForm.controls.productImage.errors?.required">
                                Icon is required.
                              </div>
                  </div>
                      
                  <a href="javascript:void(0)" *ngIf="addProductForm.get('productImage')?.valid" (click)="removeFile()"
                              class="position-absolute" style="top: 10px; right: 180px; color: #dc3545;">
                              <i class="fa fa-times-circle fa-lg"></i>
                  </a>
                  <p style="font-size: 13px; margin-top: 4px;">PNG/JPG with max size 50 KB allowed.</p>
              </div>
            </div>
        </div>
        <div class="col-sm-6">
          <div class="card border-0 shadow-none text-center">
            <div class="card-body">
                <br>
                <br>
                <p class="card-text">Here's how it will look on Mobile App </p>
                <br>
                <img src="assets\images\app-product.png" width="300" height="80" class=" mb-3" alt="...">
            </div>
          </div>
        </div>
    </div>
    <hr >
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body">
            <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="productName">Product Name <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="productName" autocomplete="off" class="form-control" required formControlName="productName" placeholder="Enter Product Name" [ngClass]="{'is-invalid':submitted && addProductForm.controls.productName.errors}" (keypress)="onProductNameKeyPress($event)" name="productName">
                    <div class="invalid-feedback">
                        Product Name is required
                      </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="productDesc">Product Description <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="productDesc" autocomplete="off" class="form-control" required formControlName="productDesc" placeholder="Enter Product Description" [ngClass]="{'is-invalid':submitted && addProductForm.controls.productDesc.errors}" (keypress)="onProductDescKeyPress($event)" name="productDesc">
                    <div class="invalid-feedback">
                        Product Description is required
                      </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="productCode">Product Code <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="productCode" autocomplete="off" class="form-control" required formControlName="productCode" placeholder="Enter Product Code" [ngClass]="{'is-invalid':submitted && addProductForm.controls.productCode.errors}" (keypress)="onProductCodeKeyPress($event)" name="productCode">
                    <div class="invalid-feedback">
                        Product Code is required
                      </div>
                </div>
                <div class="form-group col-md-3" style="margin-top: 20px;">
                       
                    <input class="form-check-input" style="margin-top: 10px;" type="checkbox" id="creditType" value="true" formControlName="creditType" name="creditType">
                    <label class=" col-form-label form-check-label" for="creditType" style="margin-left: 5px;"> Credit Type</label>
                    <div class="invalid-feedback" style="display: block;">
                    </div>
                </div>
                
            </div>
            <br>
            <div class="row d-flex">
               
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="category">Category <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select [items]="categoryDropdownList" bindLabel="name" bindValue="id" placeholder="Select Category" (change)="categoryChange($event)" id="category" formControlName="category" required  [ngClass]="{'is-invalid':submitted && addProductForm.controls.category.errors}"  name="category">
                      </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Category is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="subCategory">SubCategory <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select [items]="subCategoryDropdownList" bindLabel="name" bindValue="id" id="subCategory" (change)="subCategoryChange($event)" formControlName="subCategory" placeholder="Select Subcategory" required  [ngClass]="{'is-invalid':submitted && addProductForm.controls.subCategory.errors}"  name="subCategory">
                    </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Subcategory is required
                        </div>
                    </div>
                </div>
                <!-- <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="status">Status <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select id="status" formControlName="status" required placeholder="Select Status"  [ngClass]="{'is-invalid':submitted && addProductForm.controls.status.errors}"  name="status">
                        <ng-option value="ACTIVE">Active</ng-option>
                        <ng-option value="INACTIVE">Inactive</ng-option>
                      </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Status is required
                        </div>
                    </div>
                </div> -->

            </div>
            <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="countryProduct">Country <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select id="countryProduct" [items]="countryDropDown" bindLabel="name" bindValue="id" placeholder="Select Country"  formControlName="countryProduct" (change)="countryProductSelect($event)" name="countryProduct">
                    </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Country is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="row d-flex">
                <div class="form-group col-md-12 ">
                    <div class="row mb-0" style="min-height: 270px">
                        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReadyMaxList($event)" (rowClicked)="onRowClicked($event)" 
                            [columnDefs]="tableSelectedColumn1" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                             [rowData]="maxAmountData" [rowModelType]="" [rowSelection]="'single'"
                            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                          </ag-grid-angular>
                        </div>
                      </div>
                </div>
            </div>
           
            <div class="row d-flex">
                <div class="form-group col-md-12 text-right">
                    <button type="submit" class="btn btn-primary">Save & Next</button>
                    <button type="button" class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
    </form> 
    </div>
    <div id="commission" class="tab-pane fade active show" [ngStyle]="{ 'display': activeTab === 'commission'? 'block' : 'none'}">
        <form #commissionAdd="ngForm" (ngSubmit)="addCommission(commissionAdd.value)" [formGroup]="addCommissionForm">
        <div class="row">
            <div class="col-lg-12">
              <div class="card border-0 shadow-none text-center">
                <div class="card-body">
                  <div class="row d-flex">
                    <div class="form-group col-md-2 ">
                        <label class="col-form-label">Product Name</label>
                        <input type="text" id="productName" readonly value="{{this.addProductForm.value.productName}}" class="form-control">
                    </div>
                    <div class="form-group col-md-2 ">
                        <label class="col-form-label">Category</label>
                        <input type="text" id="category" readonly value="{{categoryName}}" class="form-control">
                    </div>
                    <div class="form-group col-md-2 ">
                        <label class="col-form-label">Sub Category</label> 
                        <input type="text"  id="subCategory" readonly value="{{subCategoryName}}" class="form-control">
                    </div>
                    <div class="form-group col-md-3 " >
                        <label class="col-form-label" for="country">Country <span aria-hidden="true"
                                class="symbol required" style="color:red;">*</span>
                        </label>
                        <ng-select   id="country" formControlName="country" placeholder="Select Country" (change)="countrySelect()" required  [ngClass]="{'is-invalid':submittedCommission && addCommissionForm.controls.country.errors}" name="country">
                            <ng-option *ngFor="let country of countryAmountList; let i = index" [value]="countryAmountList[i].country">{{countryAmountList[i].countryName}}</ng-option>
                          </ng-select>
                        <div class="invalid-feedback">
                            <div >
                                Country is required
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-3 " *ngIf="maximumAmount">
                        <label class="col-form-label" for="maxAmount">Maximum Amount <span aria-hidden="true"
                                class="symbol required" style="color:red;">*</span>
                        </label>
                        <input type="number" id="maxAmount" class="form-control" readOnly formControlName="maxAmount" [ngClass]="{'is-invalid':submittedCommission && addCommissionForm.controls.maxAmount.errors}" name="maxAmount">
                        
                    </div>
                </div>
                <hr>
                <div class="row d-flex">
                    <div class="form-group col-md-3 " *ngIf="maximumAmount">
                        <label class="col-form-label" for="type">Type<span aria-hidden="true"
                                class="symbol required" style="color:red;">*</span>
                        </label>
                        <ng-select id="type"  formControlName="type" (change)="typeSelect()" required [ngClass]="{'is-invalid':submittedCommission && addCommissionForm.controls.type.errors}" name="type">
                  
                            <ng-option diabled selected value="">Select Type</ng-option>
                            <ng-option value="DIRECT">Direct</ng-option>
                            <ng-option value="SLAB">Slab</ng-option>
                          </ng-select>
                        <div class="invalid-feedback">
                            <div >
                                Type is required
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="form-group col-md-12 "  *ngIf="selectedDirect">
                            <div class="d-flex mb-2 justify-content-between">
                                <h5 class="text-left">Direct</h5>
                                <div class="text-right">
                                    <button type="button" class="btn btn-primary" *ngIf="showAddDirectSlabButton" (click)="addDirectSlab()">Add Direct</button>
                                    <button type="button" class="btn btn-primary"  (click)="selectSpecificAmount()">Add Specific Amount</button>
                                    <button type="button" class="btn btn-primary" (click)="clearTable('DIRECT')">Clear</button>
                                </div>
                            </div>
                            <div class="row mb-0" style="min-height: 270px">
                                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                  <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                                    [columnDefs]="tableSelectedColumnDirect" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                     [rowData]="directData" [rowModelType]="" [rowSelection]="'single'"  (cellValueChanged)="onCellValueChanged($event)"
                                    [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                                  </ag-grid-angular>
                                </div>
                              </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="form-group col-md-12 " *ngIf="selectedSlab">
                            <div class="d-flex mb-2 justify-content-between">
                                <h5 class="text-left">Slab</h5>
                                <div class="text-right">
                                    <button type="button" class="btn btn-primary" (click)="addRow()">Add Slab</button>
                                    <button type="button" class="btn btn-primary"  (click)="selectSpecificAmount()">Add Specific Amount</button>
                                    <button type="button" class="btn btn-primary" (click)="clearTable('SLAB')">Clear</button>
                                </div>
                            </div>
                            <div class="row mb-0" style="min-height: 270px">
                                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                  <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                                    [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                     [rowData]="slabData" [rowModelType]="" [rowSelection]="'single'"  (cellValueChanged)="onCellValueChanged($event)"
                                    [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                                  </ag-grid-angular>
                                </div>
                              </div>
                        </div>
                    </div>
                   
                </div>
                  
                  
                  <div class="row d-flex">
                      <div class="form-group col-md-12 text-right">
                          <button type="button" class="btn btn-secondary" id="cancelButton" (click)="switchTab('product')">Back</button>
                          <button type="submit" class="btn btn-primary" *ngIf="saveButtonVisible">Save</button>
                          <button type="button" class="btn btn-danger" id="cancelButton" (click)="cancelButton()">Cancel</button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
    </div>
    </div>
  
</div>